export default {"src":"/_next/static/media/setup-sip.6aed6a14.svg","height":133,"width":164,"blurWidth":0,"blurHeight":0};